import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {postponeSsoDraftById} from 'src/openapi/admin/apis/SsoDraftsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    draftId: number,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const usePostponeDraft = ({draftId, onSuccess, onFail}: Props) => {
    const dispatch = useAppDispatch();
    const eventDispatch = useCallback(() => dispatch(postponeSsoDraftById({draftId})), [dispatch, draftId]);

    return useCommonEventHook({eventAction: eventDispatch, onSuccess, onFail});
};
